// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoThumbnail_wrapper__12PKv","imgContainer":"VideoThumbnail_imgContainer__3fs3d","name":"VideoThumbnail_name__uNWDB"};